import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import './FileCard.css';

const FileCard = ({ file, index, selectedFileIndex, onSelect, onDelete, onSave, isSavedDisabled }) => {
  return (
    <Box
      className={`file-card ${selectedFileIndex === index ? 'selected' : ''} ${file.isSaved ? 'saved' : ''}`}
      onClick={() => onSelect(index)}
      role="button"
      tabIndex={0}
      aria-label={`${file.name} - ${file.isSaved ? 'Saved' : 'Not saved'} - ${selectedFileIndex === index ? 'Selected' : 'Not selected'}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(index);
        }
      }}
    >
      {/* Processing Indicator */}
      {file.isProcessing && (
        <div className="file-card-processing" aria-label="Processing">
          <div className="file-card-processing-icon" />
        </div>
      )}

      {/* File Type Badge */}
      <div className="file-card-type-badge">PDF</div>

      {/* Thumbnail */}
      <div className="file-card-thumbnail">
        <img
          src={file.thumbnail || '/default_thumb.jpg'}
          alt={`${file.name} thumbnail`}
          loading="lazy"
        />
      </div>

      {/* File Name */}
      <Typography
        variant="caption"
        className="file-card-name"
        title={file.name}
      >
        {file.name.length > 25 ? file.name.substring(0, 22) + '...' : file.name}
      </Typography>
      
      {/* Action Buttons */}
      <div className="file-card-actions">
        <Button
          variant="outlined"
          color="error"
          size="small"
          className="newt-button newt-button-primary"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(file.id, file.name, index);
          }}
          aria-label={`Delete ${file.name}`}
        >
          Delete
        </Button>
        <Button
          variant="contained"
          size="small"
          className={`newt-button newt-button-primary ${file.isSaved ? 'saved' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onSave(file, index);
          }}
          disabled={isSavedDisabled(file, index)}
          aria-label={file.isSaved ? `${file.name} is saved` : `Save ${file.name}`}
        >
          {file.isSaved ? 'Saved ' : 'Save'}
        </Button>
      </div>
    </Box>
  );
};

export default FileCard;